import { LoadingCoreProps } from "./types"
import React from "react"
import { ActivityIndicator } from "~/ui/primitives"
import { useTheme } from '~/ui/styled'

export const LoadingCore: React.FC<LoadingCoreProps> = ({ size = "small", color }) => {
  const theme = useTheme()
  const realColor = color || theme.colors.border
  return <ActivityIndicator size={size} color={realColor} />
}
